export default () => {
  const exportListElements = document.querySelectorAll(
    '[data-behaviour="export-list"] [data-behaviour~="export-element"]'
  )

  const exportList = document.querySelector('[data-behaviour="export-list"]')
  const dropzone = document.querySelector('[data-behaviour="export-dropzone"]')

  requestAnimationFrame(() => {
    if (exportListElements.length === 0) {
      dropzone.style.display = 'block'
      exportList.classList.add('export-dropzone')
    } else {
      dropzone.style.display = 'none'
      exportList.classList.remove('export-dropzone')
    }
  })
}
